import React from 'react';
import classnames from 'classnames';

const ProgressBar = ({ className, progress, reverse }) => {
  const classes = classnames(
    'progressBar',
    className, {
      'progressBar--bikeStill': progress < 5
    }
  );

  const fillStyle = {
    right: `${ 100 - (progress || 0) }%`
  };

  const fillClasses = classnames(
    'progressBar__fill', {
      reverse
    }
  );

  return <div className={ classes } role="progressbar" aria-valuenow={ progress } aria-valuemin="0" aria-valuemax="100" aria-live="polite" tabIndex="0">
    <div className={ fillClasses } style={ fillStyle }/>
  </div>;
};

export default ProgressBar;
